import { FiSearch, FiMenu, FiUser } from "react-icons/fi";

const CinescapeHeader = () => {
  return (
    <header className="bg-black text-white fixed top-0 z-50 px-4 py-3 md:px-32 flex items-center justify-between w-full">
      {/* Left: Logo */}
      <div className="flex items-center gap-2 shrink-0">
        <img src="/logo.png" alt="Cinescape" className="h-10 object-cover" />
      </div>

      {/* Center (hidden on mobile) */}
      <div className="hidden md:flex items-center gap-6 text-sm font-light">
        <div className="flex items-center gap-1 text-neutral-400 cursor-pointer hover:text-gray-300 whitespace-nowrap">
          <FiSearch className="w-4 h-4" />
          SEARCH
        </div>
        <div className="text-xl text-neutral-400 cursor-pointer">ع</div>
        <FiUser className="w-4 h-4 text-neutral-400" />
        <div className="cursor-pointer text-neutral-400 hover:text-gray-300 whitespace-nowrap">MENU</div>
        <FiMenu className="w-5 h-5 text-neutral-400" />
      </div>

      {/* Right: Collapsed menu on mobile */}
      <div className="md:hidden flex items-center gap-4">
        <FiSearch className="w-5 h-5" />
        <FiUser className="w-5 h-5" />
        <FiMenu className="w-6 h-6" />
      </div>
    </header>
  );
};

export default CinescapeHeader;
